export const quizQuestions = [
  {
    id: "question15",
    videoId: "video15",
    topic: "Driving",
    question: "I can change lane when I see:",
    options: ["Double Yellow Lines", "Dashed White Line", "Solid White Line"],
    correctAnswer: "Dashed White Line",
    descriptionTitle: "Changing Lanes",
    description1:
      "Traffic light warning signs are used to alert drivers to the presence of a traffic signal (usually a traffic light) ahead and to provide advance notice of its operation. These signs serve as a visual cue to drivers, giving them time to slow down, anticipate the upcoming traffic signal, and respond safely and appropriately to the changing traffic conditions. It's important for drivers to be attentive and follow these signs to ensure safe and orderly traffic flow.",
  },
];
